import { Handshake } from 'lucide-react';
import { useT } from '../../i18n';
import type { MeLink } from '../../lib/api/me';

/**
 * «BOOK BANER HOS PARTNERSENTERET» — the door on the club's home page
 * (slice 4c, 2026-10-20).
 *
 * Drawn only from `/me`'s link reach for the club the portal is acting in:
 * the centres where an active co-operation gave the club
 * `link.booking.create` AND this person holds the matching right at home —
 * the server's own rule, already applied. So whoever arranges play (an
 * activity or tournament leader) sees it, and nobody sees a door the server
 * would refuse. Its own component because the home view is a legacy surface
 * whose strings are not yet in the catalog, and these are.
 */
export function PartnerCourtsCard({
  hosts,
  onOpen,
}: {
  /** Absent reads as none — a caller that does not know draws no door. */
  hosts?: MeLink[];
  onOpen: (host: MeLink) => void;
}) {
  const t = useT();
  if (!hosts || hosts.length === 0) return null;
  return (
    <section
      className="max-w-6xl mx-auto px-4 md:px-6 pt-6"
      data-testid="partner-courts"
      aria-label={t('partnerCourts.title')}
    >
      <div className="card p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <p className="text-sm text-ink-2 inline-flex items-center gap-2">
          <Handshake size={16} /> {t('partnerCourts.lead')}
        </p>
        <div className="flex flex-wrap gap-2">
          {hosts.map((h) => (
            <button
              key={`${h.linkId}:${h.homeTenantId}`}
              type="button"
              className="btn-outline text-xs"
              onClick={() => onOpen(h)}
              data-testid={`partner-courts-open-${h.hostSlug}`}
            >
              {t('partnerCourts.open', { centre: h.hostName })}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
